import {
  CustomDataSchema,
  OfferFulfillmentPrioritySchema,
  OfferNameAndDescriptionSchema,
  ScanDataConfigurationSchema,
} from '@occc/validation';
import {
  FulfillmentChannelConstraintSchema,
  fulfillmentWindowSchema,
  minimumPurchaseConstraintsSchema,
  PaymentMethodConstraintSchema,
  requiresActivationConstraintWithLimitsSchema,
} from '@occc/feat-constraints/schemas';
import { boolean, object, string } from 'zod';

import { AwardCountSchema } from './award-count.schema';

export const BasePromotionSchema = OfferNameAndDescriptionSchema.merge(
  OfferFulfillmentPrioritySchema,
).extend({
  earningMechanism: object({ id: string().optional() }).optional(),
  fulfillmentWindow: fulfillmentWindowSchema,
  minimumPurchaseConstraints: minimumPurchaseConstraintsSchema,
  paymentMethodConstraint: PaymentMethodConstraintSchema,
  fulfillmentChannelConstraint: FulfillmentChannelConstraintSchema,
  awardCount: AwardCountSchema,
  stackable: boolean().optional(),
  activation: requiresActivationConstraintWithLimitsSchema,
  customData: CustomDataSchema,
  scanDataConfiguration: ScanDataConfigurationSchema,
  displayForOrderAhead: boolean().optional(),
  campaign: object({
    uuid: string().min(1),
    name: string(),
  }).optional(),
});
